import { render } from "./TemplateOrdenes.vue?vue&type=template&id=ccda5796"
import script from "./TemplateOrdenes.vue?vue&type=script&lang=js"
export * from "./TemplateOrdenes.vue?vue&type=script&lang=js"

import "./TemplateOrdenes.vue?vue&type=style&index=0&id=ccda5796&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__